import { Book, Chapter } from '../../../types';
import { useLocation, Link } from 'wouter';

interface BackButtonProps {
  prevChapter?: Chapter;
  book: Book;
}

const Icon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path d="M18 15h-6v4l-7-7 7-7v4h6v6z" />
  </svg>
);

export const BackButton = ({ prevChapter, book }: BackButtonProps) => {
  // Get current location to extract sidebar state
  const [location] = useLocation();
  
  // Check if we have a sidebar state in the URL
  let sidebarState = null;
  const pathParts = location.split('/');
  if (pathParts.length > 5) {
    const lastPart = pathParts[5];
    if (lastPart === 'comments') {
      sidebarState = 'comments';
    } else if (lastPart === 'chapter-list') {
      sidebarState = 'chapterList';
    } else if (lastPart === 'settings') {
      sidebarState = 'settings';
    }
  }

  if (!prevChapter)
    return (
      <Link class="secondary" role="button" href={`/f/${book.permalink}`}>
        <Icon />
      </Link>
    );

  // Build URL with sidebar state if present
  const href = sidebarState === 'chapterList' ? `/f/${book.permalink}/c/${prevChapter.permalink}/chapter-list` :
              sidebarState === 'comments' ? `/f/${book.permalink}/c/${prevChapter.permalink}/comments` :
              sidebarState === 'settings' ? `/f/${book.permalink}/c/${prevChapter.permalink}/settings` :
              `/f/${book.permalink}/c/${prevChapter.permalink}`;

  return (
    <Link
      class="secondary"
      role="button"
      href={href}
    >
      <Icon />
    </Link>
  );
};
